module.exports = __webpack_public_path__ + "img/ec.fdf3ea74.svg";